import { Breadcrumb } from "antd";
import { HomeTwoTone } from "@material-ui/icons";

const PageBreadcrumb = ({ routes }) => {
  return (
    <div className="mb-4 ">
      <Breadcrumb separator="/">
        <Breadcrumb.Item style={{ fontSize: "16px" }}>
          <a href="/">
            <HomeTwoTone
              style={{
                color: "#002f53",
                marginBottom: "5px",
                fontSize: "26px",
              }}
            />
          </a>
        </Breadcrumb.Item>
        {routes.map((route, index) => (
          <Breadcrumb.Item
            style={{ color: index === routes.length - 1 && "#f3452e" }}
            href={route.pathname}
            key={`breadcrumb-${index}`}
          >
            {route.name}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default PageBreadcrumb;
